[
  {
    "url": "/_next/static/media/zkpassport-logo.0k16mlw21k.gz.png",
    "revision": null
  },
  {
    "url": "/_next/static/media/twitter-image.07yyyspqsm.s3.jpg",
    "revision": null
  },
  {
    "url": "/_next/static/media/thread.worker.0z-f_in7hfjxf.js",
    "revision": null
  },
  {
    "url": "/_next/static/media/precogLogo.0ik0l68vdf.kb.webp",
    "revision": null
  },
  {
    "url": "/_next/static/media/poap-banner.0gcs4whfk.p68.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/poap-badge.15x1buoijxe2j.png",
    "revision": null
  },
  {
    "url": "/_next/static/media/opengraph-image.0i-h502pv_l4f.png",
    "revision": null
  },
  {
    "url": "/_next/static/media/opengraph-image.07yyyspqsm.s3.jpg",
    "revision": null
  },
  {
    "url": "/_next/static/media/mateTokenV3.151p-na3u5g54.png",
    "revision": null
  },
  {
    "url": "/_next/static/media/main.worker.0.eq80judr9rc.js",
    "revision": null
  },
  {
    "url": "/_next/static/media/luma.06va65mgnpmx2.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/logo.08y0n1278ci76.png",
    "revision": null
  },
  {
    "url": "/_next/static/media/gemini.0j6kd3usmz204.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/favicon.0j38jqj0jhq1s.ico",
    "revision": null
  },
  {
    "url": "/_next/static/media/devconnect_text.0tau6-x.96v8g.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/devconnect_logo.0o7aozraovvu7.png",
    "revision": null
  },
  {
    "url": "/_next/static/media/devconnect.0.bhif1zlx610.png",
    "revision": null
  },
  {
    "url": "/_next/static/media/claim-mate.0rxs0_ppe63am.png",
    "revision": null
  },
  {
    "url": "/_next/static/media/chatgpt.172nni9uc7f-p.svg",
    "revision": null
  },
  {
    "url": "/_next/static/media/apple-icon.02a3-4xno5y1c.png",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-worker-0sjn--fhq~1cg.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-17dfey2f_x--s.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-0rgl8myfer7l3.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-0dovt6n5~t~0h.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-0_ii5e1f04t50.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/turbopack-0019zi_gbvf9s.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/18dvrweiwbxrd.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/18d75st4_t0di.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/188rpgywkx74~.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/182autto.qhzx.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/17updd-lj_9jo.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/17rsl96214-fd.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/17dui.kkx9656.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1759a_bv~~jy1.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/16j0bofepe9t9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/16j02rzo_orkw.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/16gx.iwahb5i~.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/16c346csz1d6i.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/15gw.8k7x0-ea.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/15e~iwn1sjrv2.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/15c3~.dcfl.zi.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/15c3piabfv~0u.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/15b-ta8n9md~4.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/154kxcrv23or-.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1533l0-ae2.ar.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/152xg-w_0iofz.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/14wuw5yr-.tbg.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/14oztvf.l102y.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/14nrb-h5dme7z.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/14ideff9rmhi6.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/14gahmwmdzxs-.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/14eb~t8t.1es3.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/14_fkh.w8kkup.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/148ajcz278ejp.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1473vpejqr18b.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1452c9r8j.zc8.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/13v9i1~xv5gei.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/13ne74snb46r9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1370h_cyfj~h6.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1332zwk3rcoii.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/12ysl1l6_z09g.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/12rlretz2kg7y.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/12j-f.tyq3i-c.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/128hd3k9bz-4z.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/12.fgdxj~rzd4.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/11a936pg9xukz.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/10uvlaqbz-ix~.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/10uv6lfpu04br.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/10ri61vpxfsp_.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/10i047v~wpoqu.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/10b4zrr_0_4.a.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0~urmzic8cgw9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0~rudfe8tpd00.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0~nk6ik.n27w~.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0~j-js_si_~rc.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0~b5c5ne5kj-6.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0~5knxrpox0hn.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0~55higsu.jii.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0~00i0j-w7ajd.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0~.y1j~5nunra.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0~.1my3jpbr2m.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0zrur~z08kc67.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0zn2hdp5bq17n.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0yznqf.d5n33p.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0y31qkd0sw~rw.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0y2d2zhn-pgx8.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0xthfv7ho~xo7.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0xr6d.s1rhxlb.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0xp095jbiqic-.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0xm4x_fb2s3xt.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0xbuoagv8tum..js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0x6w258g74.f6.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0x--r43q804s7.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0wkd0kzp4-o2p.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0wipl_7f-dpns.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0ue0nd0851mk5.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0u-3m6lhjb1s4.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0tzduvmy.h799.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0tvjbaldmer.c.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0tunwhsaqh3gp.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0tqca~3ox3oys.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0tpz2tq-ori2n.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0tlaodhdmaw41.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0tgekzkg.95q6.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0st8vj385zyj-.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0srqc2o~00ua~.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0spbj5j7z.n8~.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0sokivky_p90y.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0sjhyrc3-wxs_.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0s2t_0h8mi5-i.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0rz534.8.yp81.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0re5a4tt0rkza.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0q_w0pvyc8tbh.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0q_kz7-v08tgj.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0pr-i2j8mgduw.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0pqsran89h995.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0poq60h62yose.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0pg1pgse3qx7o.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0pdxla.pe_mwu.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0pa663961avm_.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0p6x1m~0re499.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0p69mm~sa7431.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0p2.c4j9u2x5w.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0p028zbbtc2mo.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0o~w3tj4qtjjt.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0oqmb9x4ipyqm.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0oaa33cm69c1t.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0o_kx4mz4_ulb.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0o6p9q818m.p1.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0o4s5-.jaghml.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0nu5iprxz1kl9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0nsr_oqr7jxp5.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0nlk8~debn6g7.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0njfawwweahox.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0nbq5g.w~b54f.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0n1..zg1vy5r~.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0mly4dn2srlrv.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0mg0.3rn81~rg.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0ljjm53vyhqyu.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0lbf4l8z.ivl..js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0l6a8abb.r.wv.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0l5z81fw_o494.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0kzge~m1k.9f3.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0kwh_vg3bamhg.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0kizlc.wvhf2q.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0kf1jntw_k3t7.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0kf.jxkk_pbzr.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0k71z3vf9hvd..js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0k2rxk3isey7a.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0j~-_jy5.0x9j.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0jwtbo.3~2wnf.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0jvk1rqwtsy~-.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0jrbhj2g3th2b.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0jr_3~i~hhxbr.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0jlhyd8o7l0c3.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0jif641noaapn.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0jg7eosreeedx.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0jfhcuyj~uv3f.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0je3jrt~hujd1.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0jboihy4cl4uo.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0iwdt91u.5fln.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0iuias-c_jkmx.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0is32dnmd-~.j.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0imkk0m-8xuxr.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0ikodwzjum_1f.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0ij0~s5woatn7.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0iifp1xesnmg9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0ii6.bjzmtipu.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0ifvs0.3zfqc6.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0ial6rygin-rv.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0i6~mq0kya-z5.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0i5s4xny7~aym.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0hv7w1drwc38u.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0hpbjy09zisg5.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0hioljfptethw.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0h93_.rrot2ut.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0h7rp2~y2z_ao.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0h-09qq3_gm33.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0gy0b~7ohbwsv.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0gmmox2e4-wxr.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0gj~0g~4g2biv.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0gi777pr0.nvr.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0gd2dolii2e23.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0g2qslnj64xq9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0g2cu9fe27yyy.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0fwu.4sz5ud9m.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0fq8330cbwnsg.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0fjv1-ukm053w.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0fc16meqpe6ty.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0fayn8f0s0eb1.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0f9_2972x1.7a.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0f7s5se1t27zj.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0f-klh57qdg4t.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0e~4eie5vzn16.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0eojej54vtj2a.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0ekw2wgnyt-z5.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0e_zza5.83bro.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0e6r9frnef1.a.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0e4x0_4b6ndsb.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0dwg~lxh_9ynx.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0dp3x9ognfj03.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0dj-_hq9oag1v.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0df---0xwfdaq.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0d4xy-3.skgmb.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0czu-p448v15e.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0ci6vou1zb_tg.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0c7r5sxd6yczw.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0c74r.~0j0srh.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0c1clop1xff9m.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0c.zz219.j47n.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0b~nge4oh~rwf.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0bcy4.rpxab.1.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0b8k~e.ri9_9n.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0b-shy44kep-u.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0b-hubuz1m40i.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0b-aq9le4n6aa.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0b-7xd_ntxe37.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0aytz2gs87rin.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0aya7-yo1dhgr.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0axym~lxv~hli.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0aj7l55030zq~.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0a-i6emahky47.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0a-6fqezpsw~t.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0_k_rq512m1qf.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0_e5~1rs_o27u.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0_7qm8il8hut8.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/09h6~q_mlr0hm.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/09cxg-3tklbyl.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/09ced1jfwrlg4.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/09_fj67k--446.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/08y7~7u~h7sml.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/08sz.dsmqyq2b.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/08jqrgecn76s8.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/08_~gz0xgxyuv.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/086sc6ne_e8mh.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/081xntgs.bk4a.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/07vxrc0qyz1.i.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/07paz1gxrpvx6.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/07lll8ut_kvbn.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0768hvqo1~zoa.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/07-8awly5z60n.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/06umfrvu4q9p3.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/06pn0i~qteq92.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/06i-7lf3d-uj9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/06f6hkldwzw1m.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/06bkqmcihbcvz.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/05~gi4ne2fdjp.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/05u_acwvtqtd5.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/05ktl8n.3_kb4.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/05g86wuodtfpi.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/05dfwdglibw67.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/05czklye_ypoc.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/04u2z5dn.kvwt.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/04sk.20wj81la.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/048wakjyiux_k.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/048uj.d2o.xu5.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/047.nej8f2i7l.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/044dnpg3h6a2m.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/040kp-5dbjb.h.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/03~yq9q893hmn.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/03zamy5bg5m.8.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/03tgwmx3heh_b.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0399msgkhf75j.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/032px2nsypf-4.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/02pyf6eutfp.z.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/02hh3083i3ybz.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/02dlx-ty113-~.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/02dgcccv0cqpo.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/024sio~f5gf6i.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/02422--a50fjh.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0224h0.5kvgo..js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/02.hw_lveyi2v.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/01~suh96to_pm.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/01~7muo6e83ky.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/01x1dea6lkt5z.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/01s05krr0ehco.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/01kvvp91tp23a.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/01g_a3pvadw03.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/01ekh0i1hukcl.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/01e7qiqg6l4t4.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/00~wnhm3v3odp.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/00wls~..hj~nl.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/00q6x_z-59n-c.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/00g8-qcz3o6x1.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/00bwzxs84dca4.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0081..ggt2rle.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/001dzjem5w2d6.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/00.vh1aws~2tm.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/00-a79635j71o.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0.~1h3.sg7wqm.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0.wqc_oozn500.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0.e2j_s9ddjqe.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0.7lq-~u6-_8l.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0.4ivgx1geq_d.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0-qzi39e_0euu.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0-q2rcl6kuypu.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0-p-vzqzjbwe4.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0-mx5l6eduay3.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0-bq.qkpm5hc~.js",
    "revision": null
  },
  {
    "url": "/_next/static/build-TfctsWXpff2fKS/_ssgManifest.js",
    "revision": null
  },
  {
    "url": "/_next/static/build-TfctsWXpff2fKS/_clientMiddlewareManifest.js",
    "revision": null
  },
  {
    "url": "/_next/static/build-TfctsWXpff2fKS/_buildManifest.js",
    "revision": null
  },
  {
    "url": "/webmcp.js",
    "revision": "ce3ab32af20fe5dbea7605254221a259"
  },
  {
    "url": "/precogLogoWhiteText.png",
    "revision": "f8574ab7e8f7ef0916fcb6817bc83150"
  },
  {
    "url": "/precogLogoBlackText.png",
    "revision": "77366bc7d83ab88f4a5f85401d098213"
  },
  {
    "url": "/precogLogo.webp",
    "revision": "dafb0711be5a5566c9502900353faddf"
  },
  {
    "url": "/openapi.json",
    "revision": "efaf98797c18ec48020ba530ba522fb2"
  },
  {
    "url": "/llms.txt",
    "revision": "077038361704d936bbd475c47ed9f4e8"
  },
  {
    "url": "/llms-full.txt",
    "revision": "e382d6eaf29a1869216cde1c4f8835dd"
  },
  {
    "url": "/favicon-v2.ico",
    "revision": "89997c38cee8d087c62ce29e1d9f5afd"
  },
  {
    "url": "/videos/tour/simulator/trading-interface.mp4",
    "revision": "232132a819aee0b820e0738ba15acaeb"
  },
  {
    "url": "/videos/tour/simulator/presentation.mp4",
    "revision": "96a08a592cb9c38b7a132498ef757b32"
  },
  {
    "url": "/videos/tour/launchpad/provide-liquidity.mp4",
    "revision": "ee0e4342e823b86ca496f51bfdae7c09"
  },
  {
    "url": "/videos/tour/launchpad/presentation.mp4",
    "revision": "eb0d531b82fbc6e63b41da17d2f2da22"
  },
  {
    "url": "/videos/tour/launchpad/go-to-create-market.mp4",
    "revision": "3f1ced92d5381667a83ac7c0fd0e01cc"
  },
  {
    "url": "/videos/tour/create-market/presentation.mp4",
    "revision": "c312873a1a4340e66a2f13b91f73c02c"
  },
  {
    "url": "/mini-app/splash.png",
    "revision": "5c48be29332f2999f2da2f76833a172f"
  },
  {
    "url": "/mini-app/screenshot2.png",
    "revision": "7f62a0311f1c25270c4ece51e0c7d72e"
  },
  {
    "url": "/mini-app/screenshot1.png",
    "revision": "5361881170630b85a684ce8632070741"
  },
  {
    "url": "/mini-app/icon.png",
    "revision": "81b2dd07028c66ada357b36d91a19089"
  },
  {
    "url": "/mini-app/banner.png",
    "revision": "20e527675a305eae5c3e4433464f8c46"
  },
  {
    "url": "/images/watermark_dark.png",
    "revision": "5f5c3d2369ba0f7aa949761a127ddc7d"
  },
  {
    "url": "/images/watermark.png",
    "revision": "981e7354846e12de3acf9d4378f23fa3"
  },
  {
    "url": "/images/pbe_light.png",
    "revision": "4b2bac0c1a9076c6ff50804942c860a0"
  },
  {
    "url": "/images/pbe_dark.png",
    "revision": "832695db9c3340c9c2c09787e686270a"
  },
  {
    "url": "/images/tetris-championship/tetris_pattern_white.png",
    "revision": "fda939f035503b7f2a9e75aa0ccd205a"
  },
  {
    "url": "/images/tetris-championship/tetris_pattern_black.png",
    "revision": "7db74921dc31835608d8f8ee7c3dc301"
  },
  {
    "url": "/images/tetris-championship/tetris_block.png",
    "revision": "9997945104699a7e11057286c9a4d142"
  },
  {
    "url": "/images/tetris-championship/gold_coin.png",
    "revision": "1cb8089059f984c3b82b93f478b20ebf"
  },
  {
    "url": "/images/tetris-championship/champion_trophy.png",
    "revision": "6ebae7ef283001a97294eaa65ca50c61"
  },
  {
    "url": "/images/partners/zkpassport/zkpassport-logo.png",
    "revision": "e1c7e07dc133351fed464ede18e5c134"
  },
  {
    "url": "/images/partners/talentProtocol/talentProtocol.svg",
    "revision": "a4532fcd4d8e51a7bb17c3f9a034d86c"
  },
  {
    "url": "/images/partners/talentProtocol/talentIcon.svg",
    "revision": "b5be67f7b1eceef4de8b9ac1a75c0b1f"
  },
  {
    "url": "/images/partners/reality/logo.png",
    "revision": "9f09b7f6b9e400f6c3790b47191b52fa"
  },
  {
    "url": "/images/partners/poap/poap-banner.svg",
    "revision": "8a6c7a62827f66112e0ea219754cca27"
  },
  {
    "url": "/images/partners/poap/poap-badge.png",
    "revision": "f7c8b9afb8797f6a3a8530d8582f1ebc"
  },
  {
    "url": "/images/partners/poap/claim-mate.png",
    "revision": "043f1d6bd8ac33eddd08da1848e485d4"
  },
  {
    "url": "/images/partners/devconnect/devconnect_text.svg",
    "revision": "37c12b0bc909878f581cf5034b245fc3"
  },
  {
    "url": "/images/partners/devconnect/devconnect_logo.png",
    "revision": "85fd3cad8be2d8e99f91563f2803c3a6"
  },
  {
    "url": "/images/partners/devconnect/devconnect.png",
    "revision": "d3387ace066f8189b02d083e09b2f956"
  },
  {
    "url": "/images/partners/crecimiento/crecimiento_light.png",
    "revision": "d48f2b2fffbf94e6a87e2e8be7119a92"
  },
  {
    "url": "/images/partners/crecimiento/crecimiento_dark.png",
    "revision": "eb713a0139196a281fd2e2512208c4c1"
  },
  {
    "url": "/images/partners/crecimiento/aleph_light.png",
    "revision": "f825c36e2de7e95f40c73d3d6a1ba080"
  },
  {
    "url": "/images/partners/crecimiento/aleph_dark.png",
    "revision": "96a6b2f541a611afa13da93ad0f1eab8"
  },
  {
    "url": "/images/OGImages/generic.png",
    "revision": "7cf7e09074de43e0700590a217d00c9d"
  },
  {
    "url": "/images/OGImages/dacc.png",
    "revision": "60050b189d2aba780af41cca65fda6aa"
  },
  {
    "url": "/images/OGImages/banner.png",
    "revision": "20e527675a305eae5c3e4433464f8c46"
  },
  {
    "url": "/images/OGImages/background.png",
    "revision": "bce96fe4b0771f37b0b624bd7166ca0a"
  },
  {
    "url": "/icons/icon.png",
    "revision": "d8218d862806f6553fefb6aed4f26a88"
  },
  {
    "url": "/icons/apple-icon.png",
    "revision": "762b6d2a5ddc9d3b649ed21c9b16c214"
  },
  {
    "url": "/icons/tokens/wbrlToken.png",
    "revision": "63622316c90a43b57bf7398b662d7ffb"
  },
  {
    "url": "/icons/tokens/warsToken.png",
    "revision": "2aaf2505f99c65f06964da1aa7471cf7"
  },
  {
    "url": "/icons/tokens/usdtToken.png",
    "revision": "c050158a5b00b091f54927f23de37285"
  },
  {
    "url": "/icons/tokens/usdsToken.png",
    "revision": "ee468332454c2d7b0882536c67ec9ada"
  },
  {
    "url": "/icons/tokens/usdcToken.png",
    "revision": "f3362ad5a12c0127b47c35fe28baffec"
  },
  {
    "url": "/icons/tokens/talentToken.png",
    "revision": "321552fc913852c90f38348e943ae2aa"
  },
  {
    "url": "/icons/tokens/susdsToken.png",
    "revision": "181b78e28663bd334dca46a3456c63fa"
  },
  {
    "url": "/icons/tokens/precogToken.png",
    "revision": "2d8850f77e5dc2c9e11547d0064ad0b6"
  },
  {
    "url": "/icons/tokens/opMainnetToken.png",
    "revision": "b7538a9591727641525f34f66ec7ec53"
  },
  {
    "url": "/icons/tokens/mateTokenV3.png",
    "revision": "73b49764a3a7c483f2bbc81f8047a720"
  },
  {
    "url": "/icons/tokens/kaitoToken.png",
    "revision": "c0e9d2d386debc404a99a83ac2429001"
  },
  {
    "url": "/icons/tokens/defaultTokenv2.png",
    "revision": "f1ab5fad984e7372adcdb8442275b84c"
  },
  {
    "url": "/icons/tokens/bnkrToken.png",
    "revision": "0e6cee145f94b8de3f47697851ee2019"
  },
  {
    "url": "/icons/tokens/arbToken.png",
    "revision": "e496b0d8d2b637bd961381ab83a76fd7"
  },
  {
    "url": "/icons/social-media/telegram.svg",
    "revision": "74addc7c3c3337ceca851dce799e43d0"
  },
  {
    "url": "/icons/social-media/luma.svg",
    "revision": "fc4e42761a4bd905320dc5e1f204a102"
  },
  {
    "url": "/icons/social-media/instagram.svg",
    "revision": "467b1a15d0ab19872aaa1ff4896fc4e9"
  },
  {
    "url": "/icons/social-media/gemini.svg",
    "revision": "0b0e429cf7434b4a1cec0671a894ae91"
  },
  {
    "url": "/icons/social-media/discord.svg",
    "revision": "f316f3caa51a1d8ceec0176571ebbc99"
  },
  {
    "url": "/icons/social-media/chatgpt.svg",
    "revision": "61abe082f8906fa2928d2421ea2f6708"
  },
  {
    "url": "/icons/social-media/X.svg",
    "revision": "7b3365932c934b014216976f08f6d8a0"
  },
  {
    "url": "/icons/social-media/M.svg",
    "revision": "9acdafa96c365d9e8654544c8382d64d"
  },
  {
    "url": "/icons/chains/sepolia.svg",
    "revision": "e93152fb44a7b9c73746be03259885f9"
  },
  {
    "url": "/icons/chains/polygon.svg",
    "revision": "85eeec0cd90698575664e6085c5f1254"
  },
  {
    "url": "/icons/chains/optimism.svg",
    "revision": "da91c2003d01cfc831cd55974b358fb5"
  },
  {
    "url": "/icons/chains/mainnet.svg",
    "revision": "056183b73906c61c7a61a4258f854448"
  },
  {
    "url": "/icons/chains/ethereum-original.svg",
    "revision": "2b470564821c19dc383cf82898a868e4"
  },
  {
    "url": "/icons/chains/ethereum-original-light.svg",
    "revision": "df3f7e443526471827e1ef8871b25afd"
  },
  {
    "url": "/icons/chains/bnb.svg",
    "revision": "538cd8ce9c147aac4099a9307ce4df5d"
  },
  {
    "url": "/icons/chains/baseSepolia.svg",
    "revision": "6ba6814ed5ac1075946aa9ec08a3d693"
  },
  {
    "url": "/icons/chains/base.svg",
    "revision": "880c8fd34fd7f367ad1d93fb637a37a2"
  },
  {
    "url": "/icons/chains/arbitrum.svg",
    "revision": "0cee5b9c7da8ecb3308348468cf6d35e"
  },
  {
    "url": "/icons/categories/weather.svg",
    "revision": "8b05c25254dac020c57d9cf69e995240"
  },
  {
    "url": "/icons/categories/us.svg",
    "revision": "ffee5fbfb4b84c9d9c6f13e615e9179a"
  },
  {
    "url": "/icons/categories/trend.svg",
    "revision": "ce2126a4f4a9d95d9ec6483f0158169f"
  },
  {
    "url": "/icons/categories/travel.svg",
    "revision": "9da10c2a2ebfce35f3dd9460f1818c9c"
  },
  {
    "url": "/icons/categories/transport.svg",
    "revision": "917102d39dbf61a80fa4feced12996de"
  },
  {
    "url": "/icons/categories/tech.svg",
    "revision": "4545ca6cdc282b657cc36baadd569c03"
  },
  {
    "url": "/icons/categories/sports.svg",
    "revision": "dae76548f3c05bc28ca40805a9d91de6"
  },
  {
    "url": "/icons/categories/space.svg",
    "revision": "907d579e1dbfb33b39288e1018b756e6"
  },
  {
    "url": "/icons/categories/soccer-passes.svg",
    "revision": "1232697ace84f8c7ca9cb6ef710ebfad"
  },
  {
    "url": "/icons/categories/sentiment.svg",
    "revision": "3ec706711533b64fd936d18cc89f00d7"
  },
  {
    "url": "/icons/categories/science.svg",
    "revision": "616ccbf68ce4ca58a062110ae53c9371"
  },
  {
    "url": "/icons/categories/robotics.svg",
    "revision": "69953dbe3dffdb6d41bfc700e816e7bc"
  },
  {
    "url": "/icons/categories/risk.svg",
    "revision": "ac13896eb6046b01c9fc97f8b8a1d170"
  },
  {
    "url": "/icons/categories/retail.svg",
    "revision": "52b1d3c61b9c12e03a4297d4a24f1d65"
  },
  {
    "url": "/icons/categories/real-estate.svg",
    "revision": "424bcf72a73a778cf0ba120d1ff604f7"
  },
  {
    "url": "/icons/categories/precog.svg",
    "revision": "80b224605219c546490db0ff99375910"
  },
  {
    "url": "/icons/categories/policy.svg",
    "revision": "15cf86ca62688f1586f04d4c248ccae5"
  },
  {
    "url": "/icons/categories/pharma.svg",
    "revision": "ba4c35065353564e27e69cf0e9ec32a2"
  },
  {
    "url": "/icons/categories/options.svg",
    "revision": "e501f941a982f31e2d3100705e9d55ae"
  },
  {
    "url": "/icons/categories/news.svg",
    "revision": "cf0e1c06650c133f5fd783f593e0fa0c"
  },
  {
    "url": "/icons/categories/music.svg",
    "revision": "db1c4b4d0a74261b7d736aa85485eb59"
  },
  {
    "url": "/icons/categories/mentions.svg",
    "revision": "6f936b56056dc8d9f6b741e2d3771f5d"
  },
  {
    "url": "/icons/categories/media.svg",
    "revision": "8bf6e7c4526c743d8eb865e63c551891"
  },
  {
    "url": "/icons/categories/materials.svg",
    "revision": "01faf4acd4746cafbfc36472edda7fea"
  },
  {
    "url": "/icons/categories/macro.svg",
    "revision": "49820be2be00afa1566e6ec5fb4f0f5f"
  },
  {
    "url": "/icons/categories/legal.svg",
    "revision": "c0bd71a2e5f08571d5f2b90c98293395"
  },
  {
    "url": "/icons/categories/index.svg",
    "revision": "5f14dfa7cf3e8d0fa567ec7f5d7145b6"
  },
  {
    "url": "/icons/categories/gaming.svg",
    "revision": "e8a2bd7bd5f2237f33f4ab618bbf7509"
  },
  {
    "url": "/icons/categories/futures.svg",
    "revision": "7dbe445e49d3dd37809e4e8f71ade7bd"
  },
  {
    "url": "/icons/categories/forecasting.svg",
    "revision": "39d27e541fe354bb3f453aa7c8c3d857"
  },
  {
    "url": "/icons/categories/finance.svg",
    "revision": "a2b6df9107d051962698957abb6d0fb3"
  },
  {
    "url": "/icons/categories/event.svg",
    "revision": "2be86c7b389b2b8fbf4d93646457cfd5"
  },
  {
    "url": "/icons/categories/etf.svg",
    "revision": "d9ede67d2ce31103e4b81b95f0232a16"
  },
  {
    "url": "/icons/categories/environment.svg",
    "revision": "8f7e9b471a461633f45643fbbf83757b"
  },
  {
    "url": "/icons/categories/energy.svg",
    "revision": "f377779c987452236339d72145bd05f9"
  },
  {
    "url": "/icons/categories/elections.svg",
    "revision": "b0974a5dd8f28c0292b605d7c11218e9"
  },
  {
    "url": "/icons/categories/demographics.svg",
    "revision": "4ae369382138e4b248e9397d7ee8e45a"
  },
  {
    "url": "/icons/categories/data.svg",
    "revision": "9c7666e579e6d0ef32a09b98d92807a0"
  },
  {
    "url": "/icons/categories/culture.svg",
    "revision": "38b88fd631b76905c1313a2e4bb61045"
  },
  {
    "url": "/icons/categories/crypto.svg",
    "revision": "46d6fb6c4a24e777f8696ef06abeb0a0"
  },
  {
    "url": "/icons/categories/contrarian.svg",
    "revision": "affa409dd09e02ae9b306ad9ab6c1aa9"
  },
  {
    "url": "/icons/categories/consumer.svg",
    "revision": "5ab0f1bd0feb9fcb22f6ee86ad9b6bb0"
  },
  {
    "url": "/icons/categories/congress.svg",
    "revision": "90c1e168b073605099b2ace75827de19"
  },
  {
    "url": "/icons/categories/companies.svg",
    "revision": "8b8ca0db60ca6df0cf3977ea44da6b59"
  },
  {
    "url": "/icons/categories/commodities.svg",
    "revision": "7706a1dee908aada2c49e31aeda4da2d"
  },
  {
    "url": "/icons/categories/colombia.svg",
    "revision": "9380d55826130eaf4293fb8c8942625d"
  },
  {
    "url": "/icons/categories/chess.svg",
    "revision": "306198c1544651a00f421cddcb806776"
  },
  {
    "url": "/icons/categories/brazil.svg",
    "revision": "cbd1be0792ef83b3b41da168d0eae830"
  },
  {
    "url": "/icons/categories/argentina.svg",
    "revision": "3c6af78b2ed860483abae2b4a1956dcc"
  },
  {
    "url": "/icons/categories/agriculture.svg",
    "revision": "4f3d6a2d19549805b4db8b7f4498651a"
  },
  {
    "url": "/fonts/SpaceGrotesk-Regular.ttf",
    "revision": "778bb9a271006ab9d103287699611325"
  },
  {
    "url": "/fonts/SpaceGrotesk-Bold.ttf",
    "revision": "52e5e29a7805a81bac01a170e45d103d"
  },
  {
    "url": "/fonts/MonumentExtended-Regular.otf",
    "revision": "73b9994bb505da43a387d107849baf95"
  },
  {
    "url": "/documents/MATE_Tokens_Terms_and_Conditions.pdf",
    "revision": "a2400b753ed6a57087b517cb535d5361"
  },
  {
    "revision": "dbe93fb85cd379795793d9f11190eac1cf29f159\n",
    "url": "/~offline"
  }
]